import { observer } from 'mobx-react-lite';
import { Navigate, Outlet, useLocation } from 'react-router-v7';
import { userStore } from 'stores/userStore/userStore';
import { routePath } from '../routes';

export default observer(function ProtectedRoute({ allowedRoles }: { allowedRoles?: string[] }) {
	const { userRole, isLogged } = userStore.userContext;
	const location = useLocation();

	if (!isLogged) {
		return <Navigate to={routePath.login} replace state={{ from: `${location.pathname}${location.hash ?? ''}` }} />;
	}

	const checkIfAuthenticated = () => {
		if (allowedRoles?.length) {
			return allowedRoles.includes(userRole);
		}
		return true;
	};

	if (!checkIfAuthenticated()) {
		return <Navigate to={routePath.error} replace />;
	}

	return <Outlet />;
});
